import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import LogoIcon from '../../images/logo.jpeg';
import Button from '../Button';

const myStyle = {
  backgroundColor: `white`,
}

const imgStyle = {
  height: `65px`,
  width:'74px',
  
}


const Header = () => (
  // <header className="sticky top-0 bg-white shadow" style={myStyle}>
  //   <div className="container flex sm:flex-row justify-between items-center mx-auto py-4 px-8" style={myStyle}>
  //     <div className="flex items-center font-bold text-2xl">
  //       <div className="mr-3">
  //         <img src={LogoIcon} style={imgStyle}/>
  //       </div>
  //       TechMillennials
  //     </div>
  //     <div className="flex mt-4 sm:mt-0">

  //       <AnchorLink className="px-4 font-bold" style={{ color: 'black' }} href="#services">
  //         Services
  //       </AnchorLink>
  //       <AnchorLink className="px-4 font-bold" style={{ color: 'black' }} href="#aboutus">
  //         About Us
  //       </AnchorLink>
  //       <AnchorLink className="px-4 font-bold" style={{ color: 'black' }} href="#contactus">
  //         Contact Us
  //       </AnchorLink>
  //     </div>
  //   </div>
  // </header>
//   <header class="header-fixed">

// 	<div class="header-limiter">

// 		<h1><a href="#title">Tech<span>Millennials</span></a></h1>

// 		<nav>
// 			<a href="#services">Services</a>
// 			<a href="#aboutus">About Us</a>
// 			<a href="#contactus">Contact Us</a>
// 		</nav>

// 	</div>

// </header>
<div class="header" style={myStyle}>
  <div class="logo">
    <img src={LogoIcon} style={imgStyle}/>
    <a href="#title">TechMillennials</a>
  </div>
  <div class="header-right">
    <a href="#services">Services</a>
    <a href="#aboutus">About Us</a>
    <a href="#contactus">Contact Us</a>
  </div>
</div>
);

export default Header;
